<div class="customer-overview-card">
  <artemis-loading-spinner *ngIf="(loading$ | async) || customerParticularsLoading"></artemis-loading-spinner>
  <div *ngIf="currentCustomer">
    <div class="customer-overview-card__content-container">
      <div class="customer-overview-card__content-column info-and-btns-container">
        <div class="basic-info">
          <div class="basic-info__name">
            <img class="themified-white-icon basic-info__type-icon"
              [src]="(currentCustomer?.customerType === 'INDIVIDUAL') ? '/assets/icons/individual-icon-gray.png' : '/assets/icons/corporate-icon-gray.png'">
            <a class="link basic-info__name-link" *ngIf="currentCustomer"
              [routerLink]="['/customers', currentCustomer.id]">{{currentCustomer?.name}}</a>
            <a href="#" class="link" *ngIf="!currentCustomer"> {{ 'customer_overview.label.unknown' | translate }} </a>
            <span class="basic-info__status" [ngClass]="{'basic-info__status_grey': currentCustomerStatus === 'DRAFT',
              'basic-info__status_accent': currentCustomerStatus === 'PENDING' || currentCustomerStatus === 'REQUEST CHANGES' || currentCustomerStatus === 'REQUIRE UPDATE' || currentCustomerStatus === 'UPDATED',
              'basic-info__status_green': currentCustomerStatus === 'CLEARED' || currentCustomerStatus === 'ACCEPTED',
              'basic-info__status_alert': currentCustomerStatus === 'REJECTED'}">
              ({{ currentCustomerStatus }})
            </span>
          </div>
          <div class="basic-info__actions">
            <button mat-icon-button [matMenuTriggerFor]="downloadDropdown" class="custom-mat-icon-button basic-info__link">
              <img class="themified-white-icon basic-info__link-icon" src="/assets/icons/download-pdf-icon.png">
            </button>
            <mat-menu #downloadDropdown="matMenu" class="custom-mat-menu-panel">
              <button mat-menu-item (click)="downloadAcceptanceForm()" title="Customer Acceptance Form">
                {{ 'customer_overview.button.customer_Acceptance_form' | translate }}
              </button>
              <button mat-menu-item (click)="downloadReport()" [disabled]="currentCustomerStatus === 'DRAFT' || currentCustomerStatus === 'PENDING' || currentCustomerStatus === 'REQUEST CHANGES' || currentCustomerStatus === 'REQUIRE UPDATE' || currentCustomerStatus === 'UPDATED'" title="Detailed Report">
                {{ 'customer_overview.button.detail_report' | translate }}
              </button>
            </mat-menu>
            <a *ngIf="currentCustomer" mat-icon-button [routerLink]="['/customers', currentCustomer.id, 'access-control']"
                class="link custom-mat-icon-button basic-info__link" routerLinkActive="basic-info__link_active" title="Access Control">
              <img class="themified-white-icon basic-info__link-icon" src="/assets/icons/access-control-icon.png">
            </a>
            <a *ngIf="currentCustomer" mat-icon-button [routerLink]="['/customers', currentCustomer.id, 'relationship-map']"
                class="link custom-mat-icon-button basic-info__link" routerLinkActive="basic-info__link_active" title="Relationship Map">
              <img class="themified-white-icon basic-info__link-icon" src="/assets/icons/relationship-map-icon.png">
            </a>
            <!-- currently adding isUserOnlyL1 and allowDeleteCustomer check to the whole menu cause now there is only one item 'delete customer' in menu -->
            <ng-container *ngIf="currentCustomer && !(isUserOnlyL1$ | async) && allowDeleteCustomer">
              <button mat-icon-button [matMenuTriggerFor]="moreActionsMenu" class="custom-mat-icon-button basic-info__link">
                <img class="themified-white-icon basic-info__link-icon" src="/assets/icons/more-vertical-icon.png">
              </button>
              <mat-menu #moreActionsMenu="matMenu" class="custom-mat-menu-panel">
                <button mat-menu-item (click)="deleteCustomer()" title="Delete Customer">
                  {{ 'customer_overview.button.delete_customer' | translate }}
                </button>
              </mat-menu>
            </ng-container>
            <artemis-popover>
              <ng-container *ngFor="let section of ('customer_overview.info.content' | translate)">
                <ng-container *ngFor="let content of section.paragraph">
                  <p>{{content}}</p>
                </ng-container>
              </ng-container>
            </artemis-popover>
          </div>
        </div>
        <div class="progress-tracker-container">
          <div *ngIf="currentCustomer" class="progress-tracker">
            <div class="progress-tracker-item">
              <button mat-button ubi-round-button class="btn btn_rounded progress-tracker-item__button"
                [routerLink]="['/customers', currentCustomer.id, 'edit']"
                routerLinkActive="progress-tracker-item_active">
                <div class="progress-tracker-item__content-container">
                  <img class="themified-white-icon progress-tracker-item__icon" src="/assets/icons/edit-icon.png">
                  <span class="progress-tracker-item__text"> {{ 'customer_overview.button.edit_profile' | translate }} </span>
                </div>
              </button>
            </div>
            <div class="progress-tracker-item" [ngClass]="{'progress-tracker-item_disabled': currentCustomerStatus === 'DRAFT' || currentCustomerStatus === 'REQUIRE UPDATE'}">
              <button mat-button ubi-round-button class="btn btn_rounded progress-tracker-item__button"
                [ngClass]="{'progress-tracker-item__button_done': currentCustomerStatus !== 'PENDING'}"
                [routerLink]="['/customers', currentCustomer?.id, 'screening']"
                [disabled]="currentCustomerStatus === 'DRAFT' || currentCustomerStatus === 'REQUIRE UPDATE'"
                routerLinkActive="progress-tracker-item_active" >
                <div class="progress-tracker-item__content-container">
                  <img class="themified-white-icon progress-tracker-item__icon" src="/assets/icons/screening-icon.png">
                  <span class="progress-tracker-item__text"> {{ 'customer_overview.button.screening' | translate }} </span>
                </div>
              </button>
            </div>
            <div class="progress-tracker-item" [ngClass]="{'progress-tracker-item_disabled': (currentCustomerStatus === 'DRAFT' || currentCustomerStatus === 'REQUIRE UPDATE') || (isIncomplete$ | async)}">
              <button mat-button ubi-round-button class="btn btn_rounded progress-tracker-item__button"
                [routerLink]="['/customers', currentCustomer?.id, 'risk-assessment']"
                routerLinkActive="progress-tracker-item_active" [disabled]="(currentCustomerStatus === 'DRAFT' || currentCustomerStatus === 'REQUIRE UPDATE') || (isIncomplete$ | async)">
                <div class="progress-tracker-item__content-container">
                  <img class="themified-white-icon progress-tracker-item__icon" src="/assets/icons/screening-icon.png">
                  <span class="progress-tracker-item__text"> {{ 'customer_overview.button.risk_assessment' | translate }} </span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <artemis-customer-particulars [hidden]="!showCustomerParticulars" (isLoading)="customerParticularsLoadingStatusHandler($event)"></artemis-customer-particulars>
    </div>
  </div>
</div>
